import React from "react";
import { Tabs, Empty, Row, Col } from "antd";
import ApplicantCard from "./ApplicantCard";

const styles = {
  container: {
    padding: "24px",
  },
  empty: {
    margin: "24px 0",
    minHeight: 200,
  },
};

const ApplicantsAssignees = ({ assignees, applicants }) => {
  const items = [
    {
      key: "1",
      label: `Başvurular (${applicants.length})`,
      children: (
        <div>
          {applicants && applicants.length > 0 ? (
            <Row justify={"start"} gutter={[16, 16]}>
              {applicants.map((applicant) => (
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={8}
                  key={applicant.personnel.id}>
                  <ApplicantCard applicant={applicant} />
                </Col>
              ))}
            </Row>
          ) : (
            <Empty
              style={styles.empty}
              description="Bu ilana başvuru bulunmuyor"
            />
          )}
        </div>
      ),
    },
    {
      key: "2",
      label: `Onaylanan Personeller (${assignees.length})`,
      children: (
        <div>
          {assignees && assignees.length > 0 ? (
            <Row gutter={[16, 16]} wrap>
              {assignees.map((assignee) => (
                <ApplicantCard
                  key={assignee.personnel.id}
                  applicant={assignee}
                />
              ))}
            </Row>
          ) : (
            <Empty
              style={styles.empty}
              description="Bu ilan için onaylanan personel henüz yok"
            />
          )}
        </div>
      ),
    },
  ];

  return (
    <div style={styles.container}>
      <Tabs defaultActiveKey="1" items={items} size="large" />
    </div>
  );
};

export default ApplicantsAssignees;
